import React from 'react';
import { getLoginUrl } from '@fff-web/fff-utilities';
import styles from './FormErrorBanner.module.css';

interface FormErrorBannerProps {
  error: {
    msg: string;
    errorCode?: string;
  };
  email?: string;
  cta?: string;
  formErrorBannerRef?: React.MutableRefObject<HTMLDivElement>;
}

const FormErrorBanner: React.FunctionComponent<FormErrorBannerProps> = ({
  error,
  email,
  formErrorBannerRef,
}) => {
  const { msg, errorCode } = error;
  const loginLinkOnError = getLoginUrl(errorCode, email);
  return (
    <div ref={formErrorBannerRef}>
      {loginLinkOnError.type === '' && msg && <div className={styles.formErrorBanner}>{msg}</div>}
      {loginLinkOnError.type === 'active' && (
        <div className={styles.formErrorBanner}>
          Oops! It looks like you&apos;re already member of FabFitFun! Please{' '}
          <a href={loginLinkOnError.url}>log in</a> or use a different email address to create
          another account.
        </div>
      )}
      {loginLinkOnError.type === 'inactive' && (
        <div className={styles.formErrorBanner}>
          Wait! It looks like you&apos;re already a member of FabFitFun.{' '}
          <a href={loginLinkOnError.url}>Request a login link</a> to reactivate your membership.
        </div>
      )}
    </div>
  );
};

export default FormErrorBanner;
